module.exports = __webpack_public_path__ + "static/media/phone.eeb3be01.png";